import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  KeyValueDiffers
} from '@angular/core';

import { IValueChangedEvent } from '../../../wizard.content';
import { filter, find, forEach } from 'lodash';
@Component({
  selector: 'wizard-user-from-group',
  templateUrl: './user.from.group.html',
  styleUrls: ['../wizard.user.style.scss'],
  providers: []
})
export class UserFromGroupComponent implements OnInit {
  stepDiffer: any = {};

  @Input() step: any;
  @Input() subStep: any;
  @Input() wizardCtrl: any;
  wizardService: any;
  grouplist: any;
  selectedAll: any;
  constructor(public differs: KeyValueDiffers) {
    this.differs = differs;
  }

  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();

  ngOnInit() {
    this.wizardService = this.wizardCtrl.wizardService;
    this.grouplist = this.step.parent.defaultParamsById.groupIds;
    this.checkCurrentUser();
    this.selectedAll = {
      isChecked: false
    };
  }

  checkCurrentUser() {
    const userName = this.step.parent.defaultParamsById.userNames[0];
    const isCurrentUser = this.wizardService.isCurrentUser(userName);
    const manageUserId = 'manageUsersPermissions';
    if (isCurrentUser) {
      forEach<any>(this.grouplist, group => {
        if (find(group.roles, role => role.id === manageUserId)) {
          group.disabled = true;
        }
      });
    }
  }

  flipValues() {
    this.selectedAll.isChecked = !this.selectedAll.isChecked;
    this.selectAllGroup();
    this.onDataValueChange.emit({
      componentId: 'add_users_to_groups',
      key: 'groupIds',
      newValue: filter(this.grouplist, { isChecked: true }),
      isValid: true
    });
  }

  flipValue(group) {
    if (!group.disabled) {
      this.selectGroup(group);
    }
    this.onDataValueChange.emit({
      componentId: 'add_users_to_groups',
      key: 'groupIds',
      newValue: filter(this.grouplist, { isChecked: true }),
      isValid: true
    });
  }

  clickDetected(event) {
    return false;
  }

  selectGroup(group) {
    group.isChecked = !group.isChecked;
    this.selectAllChechdValue();
  }
  selectAllGroup() {
    forEach(this.grouplist, (item: any) => {
      if (!item.disabled) {
        item.isChecked = this.selectedAll.isChecked;
      }
    });
  }
  selectAllChechdValue() {
    const data = filter(this.grouplist, { isChecked: true });
    this.selectedAll.isChecked = false;
    if (data.length == this.grouplist.length) {
      this.selectedAll.isChecked = true;
    }
  }

  isLoading() {
    return this.wizardService.isLoading;
  }
}
